'use client';
import cn from '@/lib/clsxm';
import { useClientSmallScreen } from '@/lib/user-agent/client';

import Container from '@/components/@base/container';
import { Text } from '@/components/@base/typography';

import DialogIcon from '~/images/icons/dialog-icon';

type MarkProps = {
  year: number | string;
  title: string;
  isLastOne?: boolean;
};
export default function Mark({ year, title, isLastOne = false }: MarkProps) {
  const isMobile = useClientSmallScreen();

  return (
    <Container className='relative'>
      {!isMobile && (
        <>
          {isLastOne && (
            <Container className='absolute right-[-55px] top-[-75px] -z-10'>
              <DialogIcon />
            </Container>
          )}
          <Container className='absolute right-[-65px]  top-[-58px] w-[130px]'>
            <Text
              className={cn(
                'text-[11px] font-medium leading-4 tracking-tight text-[#76767C]',
                isLastOne ? 'text-white' : 'text-[#76767C]',
              )}
            >
              {title}
            </Text>
          </Container>
        </>
      )}
      <Text
        className={cn(
          'absolute right-[18px] top-[-30px] text-base font-[400] leading-9 tracking-[-1px] text-[#282A2C] md:right-[-12px] md:top-0 md:block',
          isLastOne && 'text-[22px] font-[500]',
        )}
      >
        {year}
      </Text>
    </Container>
  );
}

export const markStyle = {
  marginTop: '8px',
};
